import './scss/main.scss';
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
'use strict';

/* Global Variables and Functions */
const ajaxurl = '/wp-admin/admin-ajax.php';

function updateURLParameter(url, param, paramVal) {
    let newAdditionalURL = '';
    let tempArray = url.split('?');
    const baseURL = tempArray[0];
    const additionalURL = tempArray[1];
    let temp = '';
    if (additionalURL) {
        tempArray = additionalURL.split("&");
        for (let i = 0; i < tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }

    const rows_txt = temp + '' + param + '=' + paramVal;
    return baseURL + '?' + newAdditionalURL + rows_txt;
}

function removeURLParameter(url){
    return url.split(/[?#]/)[0];
}

function changeUrl(parameter, id) {
    const currentUrl = window.location.href;
    window.history.replaceState('', '', updateURLParameter(currentUrl, parameter, id));
}

function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

/* JS Start when Document Load & DOM build*/
document.addEventListener('DOMContentLoaded', ready);
function ready() {

    /* Header Fixed */
    const scrollUpButton = document.querySelector('.js-scroll-up');
    const siteHeader = document.querySelector('.site-header');
    let headingSection = document.querySelector('.promo');
    let siteHeaderHeight = 0;
    let headingSectionHeight = 0;

    if (!headingSection) {
        headingSection = siteHeader;
    }

    if (headingSection && siteHeader) {
        headingSectionHeight = headingSection.offsetHeight;

        const headerPosition = () => {
            if (window.scrollY >= headingSectionHeight) {
                siteHeader.classList.add('fixed');
                document.body.classList.add('header-fixed');

                if (scrollUpButton) {
                    scrollUpButton.classList.add('show');
                }
            } else {
                siteHeader.classList.remove('fixed');
                document.body.classList.remove('header-fixed');

                if (scrollUpButton) {
                    scrollUpButton.classList.remove('show');
                }
            }
        }

        headerPosition();

        document.addEventListener('scroll', function () {
            headerPosition();
        });
    }

    /* Set 100vh height */
    // Get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // Listen to the resize event
    window.addEventListener("resize", () => {
        // Execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    // init Swipers
    const swiperFeatured = new Swiper('.js-products-carousel > .woocommerce', {
        modules: [Navigation, Autoplay],
        wrapperClass: 'products',
        slideClass: 'product',
        // slidesPerView: "auto",
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        // loop: true,
        // loopedSlides: 1,
        // autoplay: {
        //     delay: 3000,
        //     disableOnInteraction: true,
        //     pauseOnMouseEnter: true,
        // },
        navigation: {
            nextEl: '.js-products-arrows .swiper-button-next',
            prevEl: '.js-products-arrows .swiper-button-prev',
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1199: {
                slidesPerView: 4,
            },
        }
    });
}

/* ==========================================================================
* jQuery Scripts
* ========================================================================== */
(function($){
    $(document).ready(function() {

        /* Burger Menu Action */
        $('.js-burger').on('click', function () {
            if ($('.header__menu-wrapper').hasClass('active')) {
                $('.header__menu-wrapper').addClass('out');

                setTimeout(function () {
                    $('.header__menu-wrapper').hide();
                    $('.header__menu-wrapper').removeClass('out');
                    $('.js-burger').removeClass('active');
                    $('.header__menu-wrapper').removeClass('active');
                    $('body').removeClass('menu-open');
                }, 200)

                setTimeout(function () {
                    $('.header__menu-wrapper').show();
                }, 500)
            } else {
                $(this).addClass('active');
                $('.header__menu-wrapper').addClass('active');
                $('body').addClass('menu-open');
            }

        });

        $('.page-overlay').on('click', function () {
            $('.js-burger').trigger('click');
        });

        /* Scroll Up */
        $('.js-scroll-up').on('click', function() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        /* Scroll To Section */
        $('.js-anchor').on('click', function (e) {
            e.preventDefault();
            const anchorSection = $(this).attr('href');
            $('html, body').animate({ scrollTop: $(anchorSection).offset().top - 80}, 500, 'linear');
        });

        /* Open Search */
        $('.js-search').on('click', function(e) {
            e.preventDefault();

            $(this).toggleClass('active');
            $('body').toggleClass('modal-open');
            $('.js-search-modal').toggleClass('show');
        });

        /* Play Video */
        $('.js-play').click(function (e) {
            const post = $(this).closest($('.post-image')).length ? $(this).closest($('.post-image')) : $(this).closest($('.article__image--video'));

            $(post).addClass('active');
            const iframeYouTube = $(post).find('iframe[src*="youtube"]');

            if ($(iframeYouTube).length) {
                const src = $(iframeYouTube).attr('src').replace('autoplay=0', 'autoplay=1');
                $(iframeYouTube).attr('src', src);
            }
        });

        /* Woocommerce Single Product */
        $('body.single-product .variations').appendTo('body.single-product .woocommerce-variation-add-to-cart');

        $('body.single-product .variations select#colour').each(function () {
            $(this).on('change', function () {
                const value = $(this).val();
                console.log(!!value)
                if (value) {
                    $('div.product.type-product').addClass('variation-selected');
                } else {
                    $('div.product.type-product').removeClass('variation-selected');
                }
            })
        });

        /* Woocommerce Checkout */
        $('body').on('init_checkout', function () {

            const interval = setInterval(function () {
                if ($('.wc-block-components-checkout-return-to-cart-button').length) {
                    clearInterval(interval);

                    $('.wc-block-components-checkout-return-to-cart-button').css('pointer-events', 'all');

                    $('.wc-block-components-checkout-return-to-cart-button').on('click', function (e) {
                        e.preventDefault();
                        window.scrollTo(0, 0)

                        $('#contact-fields #email, #shipping input[required], #billing input[required]').each(function () {
                            $(this).trigger( "focus" );
                            $(this).trigger( "blur" );

                            const timeout = setTimeout(function () {
                                if ($('#contact-fields .has-error').length || $('#shipping .has-error').length || $('#billing .has-error').length) {
                                    return;
                                } else {
                                    $('body').addClass('payment-step');
                                }

                                clearTimeout(timeout);
                            }, 500)
                        });
                    })
                }
            }, 500)
        })


    });
})(jQuery, window);